import script from "./OffCanvasFieldCost.vue?vue&type=script&setup=true&lang=js"
export * from "./OffCanvasFieldCost.vue?vue&type=script&setup=true&lang=js"

import "./OffCanvasFieldCost.vue?vue&type=style&index=0&id=c0ea0c00&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c0ea0c00"]])

export default __exports__